export default () => {
    const testimonial = document.querySelector('*[testimonial-animation]');
    if (!testimonial)
        return;
    import(/* webpackChunkName: "Testimonial Animation" */ "../classes/testimonialAnimation")
        .then(({ default: TestimonialAnimation }) => {
        new TestimonialAnimation(testimonial);
    })
        .catch(() => "An error with testimonial animation occurred");
};
